module.exports = __webpack_public_path__ + "media/St 4-game console-correct.3a7852ac.wav";